import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { DollarTextField, PercentTextField } from '../components/MaskedTextField';
import style from '../styles/form';
import { LoanCard } from './card-lenses';

const validateBalance = (num) =>
  num >= 5000 && num <= 100000000 ? '' : 'Balance must be between $5,000 and $100,000,000';

const RefiCurrentLoan = ({ model, onChange, ...cardProps }) => {
  return (
    <Card title="Tell us about your current mortgage..." {...cardProps}>
      <br />
      <p style={{ marginBottom: 0 }}>What type of loan is it?</p>
      <SelectField
        labelStyle={{ paddingLeft: 0 }}
        underlineStyle={{ margin: '-1px 24px -1px 0' }}
        value={model.get('refiCurrentProduct')}
        onChange={(event, _, payload) => onChange('refiCurrentProduct', payload)}
        hintText="Select One"
      >
        <MenuItem value="Fixed30" primaryText="30 Year Fixed" />
        <MenuItem value="Fixed20" primaryText="20 Year Fixed" />
        <MenuItem value="Fixed15" primaryText="15 Year Fixed" />
        <MenuItem value="Fixed10" primaryText="10 Year Fixed" />
        <MenuItem value="ARM10" primaryText="10/1 ARM" />
        <MenuItem value="ARM7" primaryText="7/1 ARM" />
        <MenuItem value="ARM5" primaryText="5/1 ARM" />
        <MenuItem value="Other" primaryText="Other product" />
        {model.get('refiPurpose') === 'CashOut' ? (
          <MenuItem value="None" primaryText="I don't have a mortgage" />
        ) : null}
      </SelectField>

      {model.get('refiCurrentProduct') === 'None' ? null : (
        <div>
          <p style={{ marginBottom: 0 }}>What is the interest rate?</p>
          <PercentTextField
            value={model.get('refiCurrentRate')}
            onChange={onChange.bind(null, 'refiCurrentRate')}
            style={style.threeQuarters}
            floatingLabelText="Interest Rate (%)"
          />
          <div>
            <p style={{ margin: '32px 0 -8px' }}>
              What is the approximate remaining balance on your mortgage?
            </p>
            <DollarTextField
              value={model.get('purchasePrice')}
              onChange={onChange.bind(null, 'purchasePrice')}
              style={style.threeQuarters}
              floatingLabelText="Mortgage Balance ($)"
              validate={validateBalance}
            />
          </div>
          <p style={{ margin: '32px 0 -8px' }}>Do you have an FHA, USDA, or VA loan?</p>
          <BooleanRadioButtons
            name="isGovernmentLoan"
            value={model.get('isGovernmentLoan')}
            onChange={onChange.bind(null, 'isGovernmentLoan')}
          />
        </div>
      )}
    </Card>
  );
};

RefiCurrentLoan.completed = ({ model }) => {
  const isCashOut = model.get('refiPurpose') === 'CashOut';
  const hasNoLoan = model.get('refiCurrentProduct') === 'None';
  const governmentLoanAnswered = model.get('isGovernmentLoan') != null;
  return (
    (isCashOut && hasNoLoan) ||
    (['Fixed30', 'Fixed20', 'Fixed15', 'Fixed10', 'ARM10', 'ARM7', 'ARM5', 'Other'].includes(
      model.get('refiCurrentProduct')
    ) &&
      !PercentTextField.validate(model.get('refiCurrentRate')) &&
      (hasNoLoan || !DollarTextField.validate(model.get('purchasePrice'), validateBalance)) &&
      governmentLoanAnswered)
  );
};

RefiCurrentLoan.id = 'RefiCurrentLoan';

export default LoanCard(RefiCurrentLoan);



// WEBPACK FOOTER //
// ./src/cards/refi-current-loan.js